import { LoopEdgeRestartCard } from './LoopEdgeRestartCard';
import { isLoopRestartConfigurableEdge, isSelfLoopEdge, resolveLoopEdgeDisplayType, type FlowEdgeLike } from '../../edit/flowEdgeHelpers';
import type { LoopEdgeRestartData } from '../../edit/loopEdgeRestartData';

interface Props {
  readonly selectedEdge: FlowEdgeLike;
  readonly disabled?: boolean;
  readonly onRestartChange: (edgeId: string, next: LoopEdgeRestartData) => void;
}

export const FlowEdgePropertyPanel = ({ selectedEdge, disabled = false, onRestartChange }: Props) => {
  if (!isLoopRestartConfigurableEdge(selectedEdge)) {
    return (
      <div className="text-body-secondary p-2">Restart limits are available on loopback edges. Reconnect as a loopback (or self-loop) to configure them.</div>
    );
  }

  const selfLoop = isSelfLoopEdge(selectedEdge);

  return (
    <LoopEdgeRestartCard
      edgeId={selectedEdge.id ?? ''}
      edgeType={resolveLoopEdgeDisplayType(selectedEdge)}
      isSelfLoop={selfLoop}
      data={selectedEdge.data}
      disabled={disabled}
      onChange={(next) => onRestartChange(selectedEdge.id ?? '', next)}
    />
  );
};
